var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "contents",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:red;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "\u30A2\u30FC\u30C8\u30DC\u30FC\u30C9 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 75,
    height: 75,
    rx: 11.338583,
    id: "rect8",
    x: 0,
    y: 0,
    ry: 11.338583
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211714",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333
    },
    d: "m 38.527208,55.400493 c -0.06993,0.344107 -0.404979,0.593789 -0.797058,0.593789 h -0.0064 c -2.778159,-0.03996 -5.525763,-1.080436 -7.544544,-2.854232 -2.51066,-2.205659 -3.837619,-5.436982 -3.837619,-9.345011 0,-1.056226 0.172786,-2.215954 0.513607,-3.446504 0.08996,-0.323222 0.413126,-0.548694 0.786193,-0.548694 0.03192,0 0.0645,0.0016 0.09708,0.0054 0.404978,0.04328 0.711512,0.350459 0.712872,0.714539 0.03564,9.986315 6.690116,13.167999 9.549404,14.072605 0.375784,0.118936 0.597116,0.458806 0.526507,0.80836 M 37.499998,15.419153 c 0,0 -15.509337,15.913279 -15.509337,27.676417 0,11.762831 8.630479,16.485278 15.509337,16.485278 6.878858,0 15.509341,-4.722447 15.509341,-16.485278 0,-11.763138 -15.509341,-27.676417 -15.509341,-27.676417",
    id: "path839"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeak);
export default __webpack_public_path__ + "static/media/Leak.76a1fefa92130a51cb237299c5cbf78d.svg";
export { ForwardRef as ReactComponent };